import {
  PromotionTile,
  PromotionTileType,
  TileStatus,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { ProductOfferCardProps } from 'shared/components/vxl/cards/ProductOfferCard/ProductOfferCard';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';
import { Maybe } from 'shared/utils/types';

interface PromotionTilesNode extends VXLComponent {
  id: string;
  name: VXLComponentId.PRODUCT_OFFER_CARD;
  props: ProductOfferCardProps;
}

const getIcon = (tileType: PromotionTileType) => {
  switch (tileType) {
    case PromotionTileType.CreditScore:
      return 'GAUGE_C';
    case PromotionTileType.LinkedAccounts:
      return 'BANK_A';
    case PromotionTileType.SetupDirectDeposit:
      return 'CALENDAR_A';
    default:
      return 'GAUGE_C';
  }
};

const getImageBackgroundColor = (tileType: PromotionTileType) => {
  switch (tileType) {
    case PromotionTileType.CreditScore:
      return theme.color.expressive.light;
    case PromotionTileType.LinkedAccounts:
      return theme.color.expressive.blush;
    case PromotionTileType.SetupDirectDeposit:
      return theme.color.expressive.orchid;
    default:
      return theme.color.expressive.light;
  }
};

const promotionTiles = (
  tile: PromotionTile,
  dependencies: HomeCardDependencies,
): Maybe<PromotionTilesNode> => {
  if (tile.status !== TileStatus.Loaded) {
    return null;
  }
  const { title, description, promotionTileType } = tile;
  const { goToPromotionCard } = dependencies;

  function getAnalyticsId(TileType: PromotionTileType) {
    switch (TileType) {
      case PromotionTileType.CreditScore:
        return 'creditScoreSignupClicked';

      case PromotionTileType.SetupDirectDeposit:
        return 'depositTrackerClicked';

      case PromotionTileType.LinkedAccounts:
        return 'linkAccountClicked';
    }
  }
  return {
    id: tile.id,
    name: VXLComponentId.PRODUCT_OFFER_CARD,
    props: {
      titleText: title || '',
      buttonText: description || '',
      illustrationKey: getIcon(promotionTileType),
      illustrationBackgroundColor: getImageBackgroundColor(promotionTileType),
      onPress: () => {
        goToPromotionCard(promotionTileType);
      },
      analyticsId: getAnalyticsId(promotionTileType),
    },
  };
};

export default promotionTiles;
